import axios from "@/plugins/axios";
import limitations from "./limitations";
import schedules from "./schedules";
import subjects from "./subjects";

export default {
    limitations,
    schedules,
    subjects,
};
